import { render } from "./DashboardIndex.vue?vue&type=template&id=1b0bcfca"
import script from "./DashboardIndex.vue?vue&type=script&lang=js"
export * from "./DashboardIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__